module.exports = __webpack_public_path__ + "static/img/iot.7edd876.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/iot.jpg
// module id = YdCf
// module chunks = 1